import { CardContent, Typography } from '@mui/material';
import clip from 'text-clipper';

import { graphql, type DocumentType } from '@/gql';
import { Editor } from '@/modules/editor/Editor';

const NEWS_ARTICLE_CONTENT_FRAGMENT = graphql(`
  fragment newsArticleContentFields on Article {
    _id
    title
    description
  }
`);

interface Props {
  article: DocumentType<typeof NEWS_ARTICLE_CONTENT_FRAGMENT>;
  fullDescription?: boolean;
}

export const NewsArticleContent = ({ article, fullDescription }: Props) => {
  const { title, description } = article;

  return (
    <CardContent>
      <Typography gutterBottom variant="h5" color="textPrimary" component="div">
        {title}
      </Typography>
      {fullDescription ? (
        <Editor htmlContent={description} editable={false} />
      ) : (
        <Editor
          htmlContent={clip(description || '', 600, {
            html: true,
            maxLines: 10,
          })}
          editable={false}
        />
      )}
    </CardContent>
  );
};
